import { api } from "./api";
import type {
  ChangeDeviceOwnershipInput,
  CreateDeviceInput,
  Device,
  DeviceBrand,
  Frame,
  UpdateDeviceClaimCodeInput,
  UpdateDeviceInput,
} from "@/types/device";

export const deviceService = {
  getDevices: (): Promise<Device[]> =>
    api.get<Device[]>("/device").then((res) => res.data),

  getDevice: (id: number | string): Promise<Device> =>
    api.get<Device>(`/device/${id}`).then((res) => res.data),

  getDeviceHistory: (
    id: number | string,
    startDate?: number,
    endDate?: number,
  ): Promise<Frame[]> => {
    const start_date = startDate ?? Math.floor(Date.now() / 1000) - 86400;
    const end_date = endDate ?? Math.floor(Date.now() / 1000);

    return api.get<Frame[]>(`/frame/${id}/${start_date}/${end_date}`).then((res) => {
      const dataSorted = [...res.data].sort(
        (a, b) => new Date(a.time_created).getTime() - new Date(b.time_created).getTime(),
      );
      return dataSorted;
    });
  },

  getDevicesByBrand: (brandId: number | string): Promise<Device[]> =>
    api.get<Device[]>(`/device/brand/${brandId}`).then((res) => res.data),

  createDevice: (deviceData: CreateDeviceInput) => api.post("/device", deviceData),

  updateDevice: (id: number | string, deviceData: UpdateDeviceInput) =>
    api.put(`/device/${id}`, deviceData),

  updateDeviceName: (id: number | string, nameData: { name: string }) =>
    api.put(`/device/${id}/name`, nameData),

  changeDeviceOwnership: (
    deviceId: number | string,
    ownershipData: ChangeDeviceOwnershipInput,
  ) => api.put(`/device/${deviceId}/change_ownership`, ownershipData),

  updateDeviceClaimCode: (
    deviceId: number | string,
    claimCodeData: UpdateDeviceClaimCodeInput,
  ): Promise<Device> =>
    api
      .put<Device>(`/device/${deviceId}/claim-code`, claimCodeData)
      .then((res) => res.data),

  deleteDevice: (id: number | string) => api.delete(`/device/${id}`),

  deleteFramesBatch: (
    deviceId: number | string,
    frames: { fcnt: number; time_created: number }[],
  ) => api.post(`/frame/delete-batch`, { device_id: deviceId, frames }),

  deleteAllFrames: (id: number | string) => api.delete(`/frame/${id}`),

  getDeviceBrands: (): Promise<DeviceBrand[]> =>
    api.get<DeviceBrand[]>("/device/brands").then((res) => res.data),
};
